import { AfterViewInit, Component, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormControlName,
  FormGroupDirective,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  NgForm,
  NgModel,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import { getErrorMessage } from '../../../core/utils/functions';
import { TranslateModule } from '@ngx-translate/core';
import { InputSwitchModule } from 'primeng/inputswitch';
import { NgIf } from '@angular/common';

@Component({
  selector: 'eco-input-switch',
  templateUrl: './eco-input-switch.component.html',
  styleUrl: './eco-input-switch.component.scss',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EcoInputSwitchComponent),
      multi: true,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EcoInputSwitchComponent),
      multi: true,
    },
  ],
  imports: [InputSwitchModule, NgIf, TranslateModule, ReactiveFormsModule]
})
export class EcoInputSwitchComponent implements Validator, ControlValueAccessor, AfterViewInit {
  @Input() label: string = 'EMPTY';
  @Input() showLabel: boolean = true;
  @Input() readonly: boolean = false;
  @Input() trueValue: any = true;
  @Input() falseValue: any = false;
  @Output() onToggle: EventEmitter<any> = new EventEmitter<any>();
  ngControl?: NgControl;
  control = new FormControl();

  constructor(private injector: Injector) {
    // this.control.valueChanges.subscribe(value => {
    //   this.onToggle.emit(value);
    //   if (this.onChange) {
    //     this.onChange(value);
    //   }
    // });
  }

  ngAfterViewInit() {
    // const ngControl: NgControl | null = this.injector.get(NgControl, null);
    // if (ngControl) {
    //   setTimeout(() => {
    //     this.ngControl = ngControl;
    //     this.control = ngControl.control as FormControl;
    //   });
    // }
  }

  get errors() {
    return (
      (((this.ngControl as NgModel | FormControlName)?.formDirective as NgForm | FormGroupDirective)
        ?.submitted ||
        this.ngControl?.touched ||
        this.ngControl?.dirty) &&
      this.ngControl?.errors
    );
  }

  onChange = (_value: string) => { };

  onTouched = () => { };

  //Lấy ra message lỗi validate để hiển thị, nếu có nhiều lỗi -> hiển thị lỗi đầu tiên.
  getError() {
   // return getErrorMessage(this.ngControl?.errors, this.label);
  }

  //Dùng để check trường hiện tại có phải required hay không.
  checkRequire() {
    // return this.ngControl?.control?.hasValidator(Validators.required);
  }

  writeValue(value: string): void {
     this.control.setValue(value, { emitEvent: false });
     if (this.ngControl) {
       this.ngControl.control!.markAsPristine();
     }
  }

  registerOnChange(fn: (value: string) => void): void {
   // this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
   // this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    // if (isDisabled) {
    //   this.control.disable({ emitEvent: false });
    // } else {
    //   this.control.enable();
    // }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  onChangeValue(value: any) {
    this.onToggle.emit(value);
  }
}
